// extracted by mini-css-extract-plugin
export default {"ul-accordion":"UlAccordion_ul-accordion__yqDY+"};